import * as React from 'react'

export default () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m12.95 19.92 8.101-8.026-7.887-7.814M2.95 11.89h17.805'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
